import { ReactNode, useState } from "react";
import { AnimateOnScroll } from "../../../components/animate";
import { Icon } from "../../../components/icon/icon";
import { TabNav } from "../../../components/tabNav";
import { PayoutCurrency } from "../../../redux/features/payment/payment.types";
import { currencyFlags, PRODUCT_PRICING } from "../../../utils/constants";

const offers = [
  "Unlimited Events (Free & Paid)",
  "Next-Day Payouts",
  "Customisable Discount codes",
  "Automated Event Reminders",
  "QR Code Check-In",
  "Show Location After Ticket Purchase",
  "Secure Payments with Paystack",
  "Invite Co-organizers",
  "Email Blast To Guests",
];

const comingSoon = ["Recurring Events"];

const currencyOptions: {
  title: string;
  to: PayoutCurrency;
}[] = [
  {
    title: "Nigeria",
    to: "NGN",
  },
  {
    title: "Canada",
    to: "Canadian Dollars",
  },
];

const Card = ({
  className,
  children,
}: {
  className: string;
  children: ReactNode;
}) => {
  return (
    <div
      className={`rounded-2xl border border-white bg-[#F4F7FA] shadow-[0px_12px_32px_0px_rgba(0,0,0,0.08)] ${className}`}
    >
      {children}
    </div>
  );
};

export const PricingPage = () => {
  const [currency, setCurrency] = useState<PayoutCurrency>("NGN");

  return (
    <>
      <div className="absolute inset-0 flex items-end">
        <img
          alt="gradient"
          src="/assets/images/gradientBg.png"
          className="sticky bottom-0 hidden w-full object-cover md:block md:object-contain"
        />
        <img
          alt="gradient"
          src="/assets/images/gradientBgMobile.png"
          className="sticky bottom-0 block w-full object-cover md:hidden md:object-contain"
        />
      </div>
      <div className="max-width-website relative py-[74px]">
        <AnimateOnScroll
          animation="fade-up"
          delay={0.25}
          className="mx-auto flex w-full max-w-[453px] flex-col gap-4 text-center"
        >
          <h1 className="website-title">
            <span className="text-blue">Simple</span>
            <br />
            Transparent
            <br />
            Pricing
          </h1>

          <p className="website-title-text">
            Tikket only makes money when you do
          </p>
        </AnimateOnScroll>

        <AnimateOnScroll
          animation="fade-up"
          delay={0.4}
          className="mx-auto mt-12 w-fit"
        >
          <TabNav
            navs={currencyOptions.map((opt) => {
              return {
                ...opt,
                title: (
                  <>
                    {currencyFlags[opt.to]}&nbsp;&nbsp;{opt.title}
                  </>
                ),
                onClick: () => {
                  setCurrency(opt.to);
                },
              };
            })}
            activeTab={currency}
            variant="switcher"
            className="!rounded-full !bg-grey-100"
            tabClassName="!text-base !rounded-full !text-grey-800 !font-semibold !py-2 !px-6"
          />
        </AnimateOnScroll>

        <AnimateOnScroll
          animation="fade-up"
          delay={0.4}
          className="pricing-parent-card mx-auto mt-8 flex w-full max-w-[818px] flex-col gap-3 rounded-[18px] border border-white p-3"
        >
          <AnimateOnScroll animation="fade-up" delay={0.4}>
            <Card className="flex flex-row flex-wrap gap-4 p-4 md:p-6">
              <div className="flex-1">
                <p className="text-base text-grey-700 md:text-lg">
                  Our Fee Per Paid Ticket
                </p>
                <p className="font-unbounded text-[32px] font-medium leading-[100%] tracking-[-0.04em] md:text-[56px]">
                  {PRODUCT_PRICING[currency].feeText}
                </p>
              </div>

              <div className="flex h-fit min-w-fit items-center gap-2 rounded-[200px] border border-[#C1DBF1] bg-[#EDF3FB] px-2.5 py-1 text-blue">
                <Icon
                  svg="info"
                  width={18}
                  height={18}
                  className="rotate-180"
                />
                <p className="text-base font-semibold md:text-lg">
                  No fees on free tickets
                </p>
              </div>
            </Card>
          </AnimateOnScroll>

          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <AnimateOnScroll animation="fade-up" delay={0.5} className="">
              <Card className="flex flex-col flex-wrap gap-4 p-4 text-base md:px-6 md:py-5 md:text-lg">
                <p className="font-semibold text-blue">What We Offer</p>

                <div className="flex flex-col gap-4">
                  {offers.map((offer, idx) => {
                    return (
                      <div
                        key={`offer-${idx}`}
                        className="flex items-center gap-[6px]"
                      >
                        <Icon
                          svg="check"
                          width={20}
                          height={20}
                          className="text-[#95A9C5]"
                        />
                        <p className="font-medium text-grey-900">{offer}</p>
                      </div>
                    );
                  })}
                </div>
              </Card>
            </AnimateOnScroll>

            <AnimateOnScroll animation="fade-up" delay={0.6} className="">
              <Card className="flex h-full flex-col flex-wrap gap-4 p-4 text-base md:px-6 md:py-5 md:text-lg">
                <p className="font-semibold text-blue">Coming Soon</p>

                <div className="flex flex-col gap-4">
                  {comingSoon.map((offer, idx) => {
                    return (
                      <div
                        key={`offer-${idx}`}
                        className="flex items-center gap-[6px]"
                      >
                        <Icon
                          svg="circle-minus"
                          width={20}
                          height={20}
                          className="text-[#95A9C5]"
                        />
                        <p className="font-medium text-grey-900">{offer}</p>
                      </div>
                    );
                  })}
                </div>
              </Card>
            </AnimateOnScroll>
          </div>
        </AnimateOnScroll>
      </div>
    </>
  );
};
